//
// May not exceed 254 characters in length.
// Must consist of a local part and a host domain separated by the &ldquo;@&rdquo; character.
//
// The local part may not exceed 64 characters in length.
// The local part must consist of at least one letter (a-z), digit (0-9), or special character ( ` ~ ! # $ % ^ & * - _ = + { } | &apos;  / ? ).
// A "." may also be used, provided it is not the first or last character and two or more do not appear consecutively.
//
// The local part may alternatively be formated as a quoted string
// Quoted strings are wrapped in double quotes and may contain any ASCII character except for " or |.
// Exceptions include the ' or | characters which may only be used only if directly proceeded by the "\" character (i.e. \" or \\ ).
//
// The local part and host domain must be separated by the "@" character
//
// The host domain must consist of one or more second-level domain names followed by a top-level domain name.
// All domain names must be separated by a ".".
// Second-level domain names may consist of letters (a-z), digits (0-9), and the "-" character, provided it is not the first or last character.
// The top-level domain name must be at least two characters in length and begin with a letter (a-z).
// No part of the host domain may exceed 63 characters in length.
//

//
//
// kitchen sink regex
// /^(?=.{3,254}$)((?=.{1,64}$)(?!\.|.*\.\.|.*\.@)[A-Za-z0-9`~!#$%^.&*_=+{}|'/?-]+|"(?:[^\\"\n\r\f]|\\.)*")(@)((?:(?!-|.*-\.|.*\.$|.*\..$|.*\.[0-9][^.]*$)(?:(?:[a-zA-Z0-9-]){1,63}\.{0,1})+)|(?:\[(?:(?:[0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}(?:[0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\])|(?:\[(?!:[^:]|.*:::.*|.*::.*::.*|.*[A-F,a-f,0-9]{5,}.*)(?:(?:(?:::){1}(?::{0,1}[A-F,a-f,0-9]{1,4}){0,7})|(?:(?::{0,1}[A-F,a-f,0-9]{1,4}){0,7}(?:::){1})|(?::{0,1}[A-F,a-f,0-9]{1,4}){8})\]))$/
//
//

function validateEmail( address, {
	maxLength = 254,
	requireTLD = true,
	allowQuoted = false,
	allowIPv4 = false,
	allowIPv6 = false
} = {} ) {
	// check the length of the address
	let test = new RegExp( `^.{${ requireTLD ? 6 : 3 },${ maxLength > 320 ? 320 : maxLength }}$` );

	if ( !test.test( address ) ) {
		return false;
	}

	// check the format of the address
	test = /^.+@.+$/;

	if ( !test.test( address ) ) {
		return false;
	}

	// destructure the local part and host domain
	const [ , localPart, , hostDomain ] = /^(.+)(@)(.+)$/.exec( address );

	/** Local Part **/

	// check the length of the local part
	test = /^.{1,64}$/;

	if ( !test.test( localPart ) ) {
		return false;
	}

	// check the format of the local part
	test = allowQuoted
		? /^(?:(?!\.|.*\.\.|.*\.$)[A-Za-z0-9`~!#$%^.&*_=+{}|'/?-]+|"(?:[^\\"\n\r\f]|\\.)*")$/
		: /^(?!\.|.*\.\.|.*\.$)[A-Za-z0-9`~!#$%^.&*_=+{}|'/?-]+$/;

	if ( !test.test( localPart ) ) {
		return false;
	}

	/** Host Domain **/
	let domainTest = requireTLD
		? '^(?:(?=.*\\.+.*)(?!-|.*-\\.|.*\\.$|.*\\..$|.*\\.[0-9][^.]*$)(?:(?:[a-zA-Z0-9-]){1,63}\\.{0,1})+)$'
		:	'^(?:(?!-|.*-\\.|.*\\.$|.*\\..$|.*\\.[0-9][^.]*$)(?:(?:[a-zA-Z0-9-]){1,63}\\.{0,1})+)$';

	if ( allowIPv4 ) {
		domainTest += '|^(?:\\[(?:(?:[0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}(?:[0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\])$';
	}

	if ( allowIPv6 ) {
		domainTest += '|^(?:\\[(?!:[^:]|.*:::.*|.*::.*::.*|.*[A-F,a-f,0-9]{5,}.*)(?:(?:(?:::){1}(?::{0,1}[A-F,a-f,0-9]{1,4}){0,7})|(?:(?::{0,1}[A-F,a-f,0-9]{1,4}){0,7}(?:::){1})|(?::{0,1}[A-F,a-f,0-9]{1,4}){8})\\])$';
	}

	test = new RegExp( domainTest );

	if ( !test.test( hostDomain ) ) {
		return false;
	}

	return true;
}

validateEmail( 'j@c.com' );
validateEmail( 'j@c.com', { maxLength: 25 } );

export default validateEmail;
